/* eslint-disable react/prop-types */
import useAxios from "axios/httpService";
import { GetInquiryByIdUrl } from "axios/commonAPIsUrls";
import { EditCustomQuestionUrl } from "axios/commonAPIsUrls";
import { GetCustomQuestionbyIdUrl } from "axios/commonAPIsUrls";
import { NotificationManager } from "components/common/ReactNotifications";
import Loading from "components/Loading/Loading";
import { apiErrorHandler } from "helpers/apiErrorHandler";
import { isNumber } from "helpers/validations";
import { isEmpty } from "helpers/validations";
import jwtDecode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import CustomMetricsFields from "views/Common/CustomMetrics/CustomMetricsFields";

const EditCustomMetrics = () => {
  const history = useHistory();
  const { inquiryParamId, CustomParamId } = useParams();
  const [areFieldsValidated, setFieldsValidated] = useState(false);
  const [fields, setFields] = useState({
    Title: "",
    Type: "",
    Description: "",
    Area: "",
    Inquiry: "",
    MaxLength: 200,
    ValidationRegex: "",
    AddedBy: "",
    RadioButtonOptions: [],
    CheckBoxOptions: [],
  });
  const [inquiryMenu, setInquiryMenu] = useState({});

  const token = localStorage.getItem("token");
  let email = "";
  if (token) {
    const decodedToken = jwtDecode(token);
    email = decodedToken.email;
  }
  const [
    { data, loading: loadingInquiryById, error },
    ExecuteGetInquiryByIdUrl,
  ] = useAxios(GetInquiryByIdUrl(inquiryParamId, token));

  const [
    { data: dataQuestion, loading: loadingQuestion, error: errorQuestion },
    ExecuteGetCustomQuestionbyIdUrl,
  ] = useAxios(GetCustomQuestionbyIdUrl(CustomParamId, token));

  useEffect(() => {
    ExecuteGetInquiryByIdUrl();
    ExecuteGetCustomQuestionbyIdUrl();
  }, []);

  useEffect(() => {
    if (dataQuestion) {
      setFields({
        ...fields,
        Inquiry: dataQuestion.InquiryId,
        Title: dataQuestion.Title,
        Type: dataQuestion.Type,
        Description: dataQuestion.Description,
        Area: dataQuestion.Area,
        MaxLength: dataQuestion.MaxLength,
        ValidationRegex: dataQuestion.ValidationRegex,
        RadioButtonOptions:
          dataQuestion.RadioButtonOptions === null
            ? []
            : dataQuestion.RadioButtonOptions,
        CheckBoxOptions:
          dataQuestion.CheckBoxOptions === null
            ? []
            : dataQuestion.CheckBoxOptions,
        AddedBy: dataQuestion.CreatedBy,
      });
    }
  }, [dataQuestion]);

  useEffect(() => {
    if (data) {
      setInquiryMenu({
        id: data.Id,
        label: data.Description,
      });
    }
  }, [data]);

  const [{ loading }, ExecuteEditCustomQuestionUrl] = useAxios(
    EditCustomQuestionUrl(CustomParamId, token),
    {
      manual: true,
    }
  );

  const allFieldsValidated = () => {
    if (isEmpty(fields.Area)) {
      return false;
    }
    if (isEmpty(fields.Type)) {
      return false;
    }
    if (isEmpty(fields.Title)) {
      return false;
    }
    if (isEmpty(fields.Description)) {
      return false;
    }
    if (fields.Type === "Textbox") {
      if (isNumber(fields.MaxLength)) {
        return false;
      }
      if (isEmpty(fields.ValidationRegex)) {
        return false;
      }
    }
    if (fields.Type.toLowerCase() === "rating") {
      if (
        isEmpty(fields.RadioButtonOptions) ||
        fields.RadioButtonOptions.indexOf("") > -1
      ) {
        return false;
      }
    }
    if (fields.Type.toLowerCase() === "checkbox") {
      if (
        isEmpty(fields.CheckBoxOptions) ||
        fields.CheckBoxOptions.indexOf("") > -1
      ) {
        return false;
      }
    }

    return true;
  };

  const onEditCustom = async (data = fields) => {
    setFieldsValidated(true);
    if (allFieldsValidated()) {
      if (fields.Type !== "Textbox") {
        delete data.MaxLength;
        delete data.ValidationRegex;
      }
      if (fields.Type !== "Rating") {
        data.RadioButtonOptions = [];
      }
      if (fields.Type !== "Checkbox") {
        data.CheckBoxOptions = [];
      }
      const value = data.RadioButtonOptions.filter((element) => {
        return element === "d";
      });
      if (fields.Type == "Rating" && value.length > 0) {
        NotificationManager.error(
          "Failure",
          "Remove Invalid rating option d to proceed",
          5000
        );
        setFieldsValidated(false);
      } else {
        delete data.AddedBy;
        delete data.Inquiry;
        try {
          const res = await ExecuteEditCustomQuestionUrl({
            data,
          });
          NotificationManager.success("Custom Question Updated", 5000);
          history.push(`/customerAdmin/custom-metrics`);
        } catch (exception) {
          console.log("Error in Updating Custom Question", exception);
          apiErrorHandler(exception, history);
        }
      }
    }
  };

  const prerequisiteValue = {
    title: "Edit Custom Added Question",
    goBackLink: "/customerAdmin/custom-metrics",
    btnAccept: "Save", // Btn One
    disabledArea: false,
    Approve: function () {
      onEditCustom();
    },
  };
  if (loading || loadingInquiryById || loadingQuestion) {
    return <Loading loading />;
  }

  return (
    <CustomMetricsFields
      fields={fields}
      setFields={setFields}
      prerequisiteValue={prerequisiteValue}
      AreFieldsValidated={areFieldsValidated}
      inquiryMenu={inquiryMenu}
    />
  );
};

export default EditCustomMetrics;
